import React from 'react';
import { Editor } from '@tinymce/tinymce-react';
import styles from './index.module.scss';

import { UiKit } from 'components';
import * as EDITOR from './stubs';

const CONFIG = {
  plugins: EDITOR.PLUGINS,
  toolbar: EDITOR.TOOLBAR,
  menubar: EDITOR.MENUBAR,
  menu: EDITOR.MENU
};

/**
 * @param {import('@tinymce/tinymce-react').IAllProps & {
 *  label: string
 *  value: string
 *  disabled: boolean
 *  onChange: (value: string) => void
 *  error: string
 *  height: number
 *  ...restProps: import('@tinymce/tinymce-react').IAllProps
 * }} props
 */
export default function HtmlEditor({
  label = '',
  value = '',
  onChange = () => {},
  disabled = false,
  error = '',
  height = 400,
  ...restProps
}) {
  return (
    <div className={styles.container} data-error={!!error}>
      <UiKit.Label text={label} />
      <Editor
        apiKey={process.env.REACT_APP_TINY_DOCS_API_KEY}
        value={value}
        disabled={disabled}
        init={{ height, ...CONFIG }}
        onEditorChange={onChange}
        // onInit={(_, editorRef) => {}}
        {...restProps}
      />
      <UiKit.Error msg={error} hide={disabled} />
    </div>
  );
}
